"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.989 12.19q-1.93.002-3.859 0c-.735-.001-1.276-.418-1.43-1.118-.124-.564.05-1.04.489-1.415.1-.087.21-.165.3-.26.236-.247.332-.548.332-.885 0-.834-.03-1.67.013-2.502.08-1.54.804-2.73 2.15-3.477 2.51-1.396 5.597.081 6.122 2.905.05.272.07.552.073.829.01.755.005 1.51.002 2.265 0 .414.155.752.482 1.003.304.234.543.507.636.892a1.42 1.42 0 0 1-1.315 1.76 4 4 0 0 1-.187.003zm3.942-1.405.01-.03q-.062-.058-.128-.113c-.7-.556-1.033-1.285-1.028-2.176q.003-.99 0-1.98c0-.19.005-.382-.015-.571a2.79 2.79 0 0 0-3.057-2.502c-1.334.122-2.451 1.288-2.49 2.628-.023.83-.003 1.66-.01 2.49-.002.19-.02.382-.058.567a2.57 2.57 0 0 1-.98 1.553c-.043.033-.08.074-.143.133zM7.992 14q-.579.002-1.158-.002a.697.697 0 0 1-.15-1.373.7.7 0 0 1 .172-.018h2.277c.414 0 .719.295.72.693s-.304.697-.717.699q-.572.002-1.144 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertIcon16.js.map